/* eslint-disable import/no-anonymous-default-export */
import requestOptions from './requestOptions'
import maintenanceMapper from '../models/Maintenance_Mapper'
import apiValidation from '../validation/ApiRespValidation'

const prodcutsService = async (page, perPage, parameters, businessModuleId) => {
    try {
        const options = requestOptions.options('GET', parameters, '');
        const resp = await fetch(global.PRODUCTS + '/' + businessModuleId + '/' + page + '/' + perPage, options);
        const data = await resp.json();
        const response = maintenanceMapper.productsMapper(data.data);
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
};

const bodegasService = async (page, perPage, parameters, businessModuleId) => {
    try {
        const options = requestOptions.options('GET', parameters, '');
        const resp = await fetch(global.BODEGAS + '/' + businessModuleId + '/' + page + '/' + perPage, options);
        const data = await resp.json();
        const response = maintenanceMapper.bodegasMapper(data.data);
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
};

const productsServiceById = async (paremeters, businessModueId, productId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.PRODUCTS_ID + '/' + businessModueId + '/' + productId, options)
        const data = await resp.json();
        const response = maintenanceMapper.productsDetailsMapper(data.data);
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const saveProduct = async (paremeters, businessModueId, dataSave, dataSaveDetails, productId, saveType) => {
    try {
        const body = {
            "businessModueId": businessModueId,
            "dataSave": dataSave,
            "dataSaveDetails": dataSaveDetails,
            "productId": productId,
            "ip": localStorage.getItem('ip'),
            "saveType": saveType
        }
        const options = requestOptions.options('POST', paremeters, body)
        const resp = await fetch(global.SAVE_PRODUCTS, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const getMedia = async (parameters, businessModuleId, productoId) => {
    try {
        const options = requestOptions.options('GET', parameters, '');
        const resp = await fetch(global.SAVE_GET_MEDIA + '/' + businessModuleId + '/' + productoId, options);
        const data = await resp.json();
        const response = maintenanceMapper.mediaMapper(data.data);
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
};

const MAX_FILE_SIZE_MB = 20;

const saveMedia = async (paremeters, moduleId, productId, media) => {
    try {

        let totalSizeMB = 0;
        media.forEach(item => {
            totalSizeMB += item.file.size / (1024 * 1024);
        });

        if (totalSizeMB > MAX_FILE_SIZE_MB) {
            let data = {
                "message": `El tamaño total de los archivos excede el límite permitido de ${MAX_FILE_SIZE_MB} MB.`,
                "error": true,
                "variant": "error"
            };
            return data;
        }

        const formData = new FormData();
        formData.append('businessModueId', moduleId);
        formData.append('productId', productId);
        formData.append('ip', localStorage.getItem('ip'));

        media.forEach((item, index) => {
            formData.append(`media[${index}]`, item.file);
        });

        const options = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${paremeters}`
            },
            body: formData
        };

        const resp = await fetch(global.SAVE_MEDIA_PRODUCTS, options);
        const response = await resp.json();
        return response;

    } catch (error) {
        return apiValidation.apiError500(); // Manejar errores de solicitud
    }
}


const deleteProduct = async (paremeters, businessModueId, productId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.DELETE_PRODUCTS + '/' + businessModueId + '/' + productId + '/' + localStorage.getItem('ip'), options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}


const accessData = async (paremeters, businessModueId, userId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.ACCESS_DATA + '/' + businessModueId + '/' + userId, options)
        const data = await resp.json();
        const response1 = maintenanceMapper.accessDataMapper(data.data["menu"]);
        const response2 = maintenanceMapper.accessUserMenuMapper(data.data["userMenu"]);
        let response = [];
        response[0] = response1;
        response[1] = response2;
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const users = async (paremeters, businessModueId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.USERS_MODULE + '/' + businessModueId, options)
        const data = await resp.json();
        const response = maintenanceMapper.maintenanceUsersMapper(data.data);
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const usersById = async (paremeters, businessModueId, userId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.USERS_ID + '/' + businessModueId + '/' + userId, options)
        const data = await resp.json();
        const response = maintenanceMapper.maintenanceUsersMapper(data.data);
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const saveUsers = async (paremeters, businessModueId, dataSave, userId, saveType) => {
    try {
        const body = {
            "businessModueId": businessModueId,
            "dataSave": dataSave,
            "userId": userId,
            "ip": localStorage.getItem('ip'),
            "saveType": saveType
        }
        const options = requestOptions.options('POST', paremeters, body)
        const resp = await fetch(global.SAVE_USERS, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const avaliableScheduleService = async (paremeters, businessModueId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.USERS_MODULE + '/' + businessModueId, options)
        const data = await resp.json();
        const response = maintenanceMapper.maintenanceUsersMapper(data.data);
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }

}

const deleteUser = async (paremeters, businessModueId, userId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.DELETE_USERS + '/' + businessModueId + '/' + userId, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const businessInfo = async (paremeters, businessModueId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.BUSINESS_INFO + '/' + businessModueId, options)
        const data = await resp.json();
        const responseBusinessInfo = maintenanceMapper.businessMapper(data.data["businessInfo"]);
        const responsePayd = maintenanceMapper.typeMapper2(data.data["businessParametters"]);
        const responseIva = maintenanceMapper.ivaMapper(data.data["businessParametters"]);

        let response = [];
        response[0] = responseBusinessInfo;
        response[1] = responsePayd;
        response[2] = responseIva;
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const saveBusinessInfo = async (paremeters, businessModueId, dataSave) => {
    try {
        const body = {
            "businessModueId": businessModueId,
            "dataSave": dataSave,
            "ip": localStorage.getItem('ip'),
        }
        const options = requestOptions.options('POST', paremeters, body)
        const resp = await fetch(global.BUSINESS_SAVEINFO, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const saveBusinessImg = async (paremeters, businessModueId, media) => {
    try {
        let totalSizeMB = 0;
        media.forEach(item => {
            totalSizeMB += item.file.size / (1024 * 1024);
        });

        if (totalSizeMB > MAX_FILE_SIZE_MB) {
            let data = {
                "message": `El tamaño total de los archivos excede el límite permitido de ${MAX_FILE_SIZE_MB} MB.`,
                "error": true,
                "variant": "error"
            };
            return data;
        }

        const formData = new FormData();
        formData.append('businessModueId', businessModueId);
        formData.append('ip', localStorage.getItem('ip'));

        media.forEach((item, index) => {
            formData.append(`media[${index}]`, item.file);
        });

        const options = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${paremeters}`
            },
            body: formData
        };

        const resp = await fetch(global.BUSINESS_SAVEIMG, options);
        const response = await resp.json();
        return response;
    } catch (error) {
        //await logError(error.message, 'saveBusinessImg', 'maintenance.jsx')
        return { error: global.MESSAGE_ERROR_CATCH }
    }
}

const getYears = () => {
    const response = maintenanceMapper.getYearsMapper();
    return response;
}

const parameterById = async (paremeters, businessModueId, parameterId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.PARAMETER_ID + '/' + businessModueId + '/' + parameterId, options)
        const data = await resp.json();
        const response = maintenanceMapper.parameterMapper(data.data);
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}


const saveParameter = async (paremeters, businessModueId, parameterSave, parameterId, saveType) => {
    try {
        const body = {
            "businessModueId": businessModueId,
            "parameterSave": parameterSave,
            "parameterId": parameterId,
            "ip": localStorage.getItem('ip'),
            "saveType": saveType
        }
        const options = requestOptions.options('POST', paremeters, body)
        const resp = await fetch(global.SAVE_PARAMETERS, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const saveTemplates = async (paremeters, businessModueId, html, design, dataSave) => {
    try {
        const body = {
            "businessModueId": businessModueId,
            "dataSave": dataSave,
            "html": html,
            "ip": localStorage.getItem('ip'),
            "design": JSON.stringify(design)
        }
        const options = requestOptions.options('POST', paremeters, body)
        const resp = await fetch(global.SAVE_TEMPLATES, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const getTemplates = async (paremeters, businessModueId, templateId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.GET_TEMPLATES + '/' + businessModueId + '/' + templateId, options, templateId)
        const data = await resp.json();
        const response = maintenanceMapper.templatesMapper(data.data);
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const saveAccessbyUser = async (paremeters, businessModueId, userId, accessParam) => {
    try {
        const body = {
            "businessModueId": businessModueId,
            "userIdAccess": userId,
            "accessParam": accessParam,
            "ip": localStorage.getItem('ip'),
        }
        const options = requestOptions.options('POST', paremeters, body)
        const resp = await fetch(global.SAVE_ACCESS, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const saveKeysSign = async (paremeters, businessModueId, file, password) => {
    try {
        const formData = new FormData();
        formData.append('certificado', file)
        formData.append('clave', password)
        formData.append('businessModueId', businessModueId)
        formData.append('ip', localStorage.getItem('ip'))

        const options = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${paremeters}`
            },
            body: formData
        }

        //const options = requestOptions.options('POST', paremeters, formData)
        const resp = await fetch(global.USER_SAVESIGNINVOICE, options)
        const response = await resp.json()
        return response
    } catch (error) {
        return { error: global.MESSAGE_ERROR_CATCH }
    }
}

const saveBodega = async (paremeters, businessModueId, dataSave, bodegaId, saveType) => {
    try {
        const body = {
            "businessModueId": businessModueId,
            "dataSave": dataSave,
            "bodegaId": bodegaId,
            "ip": localStorage.getItem('ip'),
            "saveType": saveType
        }
        const options = requestOptions.options('POST', paremeters, body)
        const resp = await fetch(global.SAVE_BODEGA, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

export default {
    avaliableScheduleService,
    saveBodega,
    prodcutsService,
    bodegasService,
    users,
    productsServiceById,
    saveProduct,
    deleteProduct,
    usersById,
    saveUsers,
    deleteUser,
    businessInfo,
    saveBusinessInfo,
    getYears,
    saveBusinessImg,
    parameterById,
    saveParameter,
    saveTemplates,
    getTemplates,
    accessData,
    saveAccessbyUser,
    saveMedia,
    getMedia,
    saveKeysSign
}